<template>
  <div class="upsi-remarks-block" data-testid="upsi-remarks-block">
    <p class="upsi-remarks-block__label">{{ label }}</p>
    <p class="upsi-remarks-block__text">{{ text }}</p>
  </div>
</template>

<script>
import './UpsiRemarksBlock.scss';

/** Read-only label and remark text. */
export default {
  name: 'UpsiRemarksBlock',

  props: {
    label: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
};
</script>
